export class Input {
 onGroundClick:(x:number,y:number)=>void=()=>{};onManual:()=>void=()=>{};
 autoDirection:{x:number;y:number;run:boolean;speedScale:number}|null=null;
 private mouseStart:{id:number;x:number;y:number;drag:boolean}|null=null;
 manualActive(){if(this.joyId!==null)return true;for(const k of this.keys)if(!k.startsWith('Shift'))return true;return false;}
 shiftHeld(){return this.keys.has('ShiftLeft')||this.keys.has('ShiftRight');}
 x=0; y=0; yawDelta=0; pitchDelta=0; zoomDelta=0; private analogRun=false;
 private keys=new Set<string>(); private pointers=new Map<number,{x:number;y:number}>();
 private joyId:number|null=null; private origin={x:0,y:0};
 constructor(canvas:HTMLCanvasElement, joystick:HTMLElement, knob:HTMLElement) {
  const reset=()=>{this.mouseStart=null;this.autoDirection=null;this.onManual();this.keys.clear();this.pointers.clear();this.joyId=null;this.x=this.y=0;this.analogRun=false;knob.style.transform='translate(0,0)';};
  window.addEventListener('blur',reset);
  window.addEventListener('orientationchange',reset);
  screen.orientation?.addEventListener('change',reset);
  window.addEventListener('pagehide',reset);
  document.addEventListener('visibilitychange',()=>{if(document.hidden)reset();});
  window.addEventListener('keydown',e=>{if(['KeyW','KeyA','KeyS','KeyD','ShiftLeft','ShiftRight','ArrowUp','ArrowDown','ArrowLeft','ArrowRight'].includes(e.code)){e.preventDefault();this.keys.add(e.code);if(!e.code.startsWith('Shift')){this.autoDirection=null;this.onManual();}}});
  window.addEventListener('keyup',e=>this.keys.delete(e.code));
  joystick.addEventListener('pointerdown',e=>{
   if(this.joyId!==null)return; e.preventDefault();this.joyId=e.pointerId;this.autoDirection=null;this.onManual();
   const b=joystick.getBoundingClientRect();this.origin={x:b.x+b.width/2,y:b.y+b.height/2};
   joystick.setPointerCapture(e.pointerId);update(e);
  });
  const update=(e:PointerEvent)=>{
   if(e.pointerId!==this.joyId)return;
   let x=e.clientX-this.origin.x,y=e.clientY-this.origin.y;const length=Math.hypot(x,y);
   if(length>42){x*=42/length;y*=42/length;}
   this.x=x/42;this.y=-y/42;knob.style.transform=`translate(${x}px,${y}px)`;
  };
  joystick.addEventListener('pointermove',update);
  const release=(e:PointerEvent)=>{if(e.pointerId===this.joyId){this.joyId=null;this.x=this.y=0;this.analogRun=false;knob.style.transform='translate(0,0)';}};
  ['pointerup','pointercancel','lostpointercapture'].forEach(n=>joystick.addEventListener(n,release as EventListener));
  canvas.addEventListener('contextmenu',e=>e.preventDefault());
  canvas.addEventListener('pointerdown',e=>{e.preventDefault();if(e.pointerType==='mouse'&&e.button===0)this.mouseStart={id:e.pointerId,x:e.clientX,y:e.clientY,drag:false};this.pointers.set(e.pointerId,{x:e.clientX,y:e.clientY});canvas.setPointerCapture(e.pointerId);});
  canvas.addEventListener('pointermove',e=>{
   const old=this.pointers.get(e.pointerId);if(!old)return;
   if(this.mouseStart?.id===e.pointerId){
    if(!this.mouseStart.drag&&Math.hypot(e.clientX-this.mouseStart.x,e.clientY-this.mouseStart.y)<=6)return;
    this.mouseStart.drag=true;
   }
   if(this.pointers.size===2) {
    const other=[...this.pointers.entries()].find(([id])=>id!==e.pointerId)![1];
    this.zoomDelta+=(Math.hypot(old.x-other.x,old.y-other.y)-Math.hypot(e.clientX-other.x,e.clientY-other.y))*.025;
   }else{this.yawDelta+=(e.clientX-old.x)*.006;this.pitchDelta+=(e.clientY-old.y)*.004;}
   this.pointers.set(e.pointerId,{x:e.clientX,y:e.clientY});
  });
  canvas.addEventListener('pointerup',e=>{
   const start=this.mouseStart;
   if(start?.id===e.pointerId){this.mouseStart=null;if(e.pointerType==='mouse'&&e.button===0&&!start.drag&&Math.hypot(e.clientX-start.x,e.clientY-start.y)<=6&&this.joyId===null&&document.elementFromPoint(e.clientX,e.clientY)===canvas)this.onGroundClick(e.clientX,e.clientY);}
  });
  ['pointerup','pointercancel','lostpointercapture'].forEach(n=>canvas.addEventListener(n,((e:PointerEvent)=>{this.pointers.delete(e.pointerId);if(this.mouseStart?.id===e.pointerId)this.mouseStart=null;}) as EventListener));
  canvas.addEventListener('wheel',e=>{e.preventDefault();this.zoomDelta+=e.deltaY*.01;},{passive:false});
 }
 direction() {
  if(this.autoDirection)return this.autoDirection;
  const kx=(this.keys.has('KeyD')||this.keys.has('ArrowRight')?1:0)-(this.keys.has('KeyA')||this.keys.has('ArrowLeft')?1:0);
  const ky=(this.keys.has('KeyW')||this.keys.has('ArrowUp')?1:0)-(this.keys.has('KeyS')||this.keys.has('ArrowDown')?1:0);
  if(kx||ky){const n=Math.hypot(kx,ky);return {x:kx/n,y:ky/n,run:this.keys.has('ShiftLeft')||this.keys.has('ShiftRight'),speedScale:1};}
  const n=Math.min(1,Math.hypot(this.x,this.y));
  if(n<=.15){this.analogRun=false;return {x:0,y:0,run:false,speedScale:0};}
  if(n>.58)this.analogRun=true;else if(n<.52)this.analogRun=false;
  // Continuous speed curve; hysteresis affects gait, never produces a speed jump.
  const speed=n<=.55?2.5*(n-.15)/.4:2.5+3*(n-.55)/.45;
  return {x:this.x/n,y:this.y/n,run:this.analogRun,speedScale:speed/(this.analogRun?5.5:2.5)};
 }
}
